<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-35">
                <client-card
                    title="Informations"
                    icon="info">
                    <template v-slot:content>
                        <client-informations :client="client"></client-informations>
                    </template>
                </client-card>
	            <client-card style="margin-top: 40px;"
		            title="Notes"
		            icon="sticky-note">
		            <template v-slot:content>
			            <client-notes :client="client"></client-notes>
		            </template>
	            </client-card>
            </div>
            <div class="md-layout-item md-size-65">
	            <client-card
		            title="Contacts"
		            icon="address-book">
		            <template v-slot:content>
			            <contacts-index></contacts-index>
		            </template>
	            </client-card>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-large-size-100 md-xlarge-size-35">
                <client-card
	                title="Sites / Contrats"
	                icon="file-contract">
                    <template v-slot:content>
                        <client-sites-contracts :client-id="client.id"></client-sites-contracts>
                    </template>
                </client-card>
            </div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-65">
                <client-card
	                title="Interventions"
	                icon="list-alt">
                    <template v-slot:header-actions>
                        <div class="mr-3">
                            <md-button class="md-icon-button md-raised md-info"
                                       @mousedown="goToRoute($event, 'Add Intervention', {}, { clientId: client.id })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'plus-circle']" />
                                <span class="leading-none ml-2 font-medium">Ajouter une intervention ponctuelle</span>
                            </md-button>
                        </div>
                        <div class="mr-3">
                            <md-button class="md-icon-button md-raised md-info"
                                       @mousedown="goToRoute($event, 'Demand Add', {}, { clientId: client.id })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'plus-circle']" />
                                <span class="leading-none ml-2 font-medium">Ajouter une demande</span>
                            </md-button>
                        </div>
                        <div>
                            <md-button class="md-icon-button md-raised md-info"
                                       @mousedown="goToRoute($event, 'Planning Management', {}, {clientId: client.id, year: $moment().format('YYYY'), type: 'contracts'})">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'list']" />
                                <span class="leading-none ml-2 font-medium">Voir les interventions à planifier</span>
                            </md-button>
                        </div>
                    </template>
                    <template v-slot:content>
                        <client-interventions type="client"></client-interventions>
                    </template>
                </client-card>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <client-card
                    title="Demandes"
                    icon="phone">
                    <template v-slot:header-actions>
                        <div>
                            <md-button class="md-icon-button md-raised md-info"
                                       @mousedown="goToRoute($event, 'Demand Add', {}, { clientId: client.id })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'plus-circle']" />
                                <span class="leading-none ml-2 font-medium">Ajouter une demande</span>
                            </md-button>
                        </div>
                    </template>
                    <template v-slot:content>
                        <client-demands></client-demands>
                    </template>
                </client-card>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import ClientCard from "@/pages/Clients/components/ClientCard";
import ClientInformations from "@/pages/Clients/Informations/Informations";
import ContactsIndex from "@/pages/Clients/Contacts/Contacts";
import ClientNotes from "@/pages/Clients/Notes/Notes";
import ClientSitesContracts from "@/pages/Clients/Sites-Contracts/Sites-Contracts";
import ClientDemands from "@/pages/Clients/Demandes/Demands";
import ClientInterventions from "@/components/Tables/DetailInterventionsTable";

// Mixins
import routerMixin from "@/mixins/router-mixin";

export default {
    name: "ClientDetails",
    components: { ClientCard, ClientInformations, ContactsIndex, ClientNotes, ClientSitesContracts, ClientDemands, ClientInterventions },
    mixins: [routerMixin],
    data() {
        return {
            client: {
                contacts: [],
                sites: []
            },
        }
    },
    methods: {
        async getClientDetails() {
            let { data } = await this.$store.dispatch('clients/getClientDetails', this.$route.params.id)
            this.client = {
                ...data,
                state: data.is_client_area_available ? "Activé" : "Désactivé",
                creation: this.$moment(data.created_at).format("DD MMMM yyyy"),
                modification: this.$moment(data.updated_at).format("DD MMMM yyyy")
            }
        },
    },
    mounted() {
        this.getClientDetails()
    }
}
</script>

<style scoped lang="scss">

.md-layout.md-gutter {
    margin: 0;
    .md-layout-item {
        padding: 0 10px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
}

.md-badge {
    position: relative;
}

.md-success {
    background: linear-gradient(60deg, #66bb6a, #43a047);
}

.text-bold {
    font-weight: 500;
}

.button-full-width {
    width: 100%;
}

</style>
